<template>
  <div @click="closeEditPageName" class="bigScreen-list">
    <div class="page-top verticallyCenter">
      <div class="page-top-l">
        <a @click="backHistory" class="colfff8 backpage"><span class="icon-portal-return mr8"></span>返回</a>
      </div>
      <div class="flex1 talign-center">页面管理</div>
      <div class="page-top-r"></div>
    </div>
    <div class="w1000 middle-content">
      <div class="verticallyCenter page-sets mb16">
        <div>
          <el-button type="primary" @click="openTemplatePop"><span class="icon-portal-plus mr8"></span>新增页面</el-button>
        </div>
        <div class="verticallyCenter">
          <el-button class="colorfff" type="text" @click="openSettingPop"
            ><span class="icon-portal-setting1 mr8"></span>页面切换设置</el-button
          >
        </div>
        <div class="verticallyCenter" style="display: none">
          <div class="mr24">
            <cx-select :value.sync="autoplay" :selectOptions="selectOption" title="页面切换模式" themeKey="stage" />
          </div>
          <div class="mr24 verticallyCenter">
            <slider-and-input
              v-show="autoplay"
              :showSlider="false"
              :value.sync="autoPlaySpeed"
              :sliderMax="3600"
              title="页面切换频率"
              suffix="秒"
              themeKey="stage"
            />
            <cx-check-box v-if="!autoplay" :value.sync="showArrow">开启切换按钮</cx-check-box>
            <!--<cx-check-box v-if="!autoplay" :value.sync="showPagination" class="ml16">开启分页指示器</cx-check-box>-->
          </div>
          <div>
            <el-button type="primary" plain class="save" size="medium" @click="savePageSet(false)">保存</el-button>
          </div>
          <!-- <cx-check-box :value.sync="autoplay" themeKey="stage">自动轮播</cx-check-box> -->
        </div>
      </div>
      <ul>
        <li class="page-list verticallyCenter" v-if="pagelist.length > 0">
          <img class="page-cover" :src="pagelist[0].cover" alt="" />
          <div v-show="editIndex !== 0" class="page-name">
            <div class="verticallyCenter">
              <p class="overflowHid2 mr8">
                {{ pagelist[0].name }}
              </p>
              <span class="icon icon-portal-edit hover-show" @click.stop="editPageName(0, pagelist[0].name)"></span>
            </div>
            <p class="fs13 first-tip">首屏不可删除或调整顺序</p>
          </div>
          <div v-show="editIndex === 0" class="verticallyCenter page-name">
            <input class="page-name-inp" type="text" v-model="pageName" />
            <span class="fs14 baseColor mr16 handle-btn" @click="cancleEditPageName">取消</span>
            <span class="fs14 baseColor handle-btn" @click="saveEditPageName(pagelist[0])">保存</span>
          </div>
        </li>
      </ul>
      <draggable element="ul" v-model="pagelistNew" handle=".mover" class="pagelist" @end="onEnd">
        <li class="page-list verticallyCenter" v-if="index > 0" v-for="(page, index) in pagelistNew" :key="index">
          <span class="mover icon icon-portal-drag hover-show"></span>
          <img class="page-cover" :src="page.cover" :key="index" alt="" />
          <div v-show="editIndex !== index" class="verticallyCenter page-name">
            <p class="overflowHid2 mr8">
              {{ page.name }}
            </p>
            <span class="icon icon-portal-edit hover-show" @click.stop="editPageName(index, page.name)"></span>
          </div>
          <div v-show="editIndex === index" class="verticallyCenter page-name">
            <input class="page-name-inp" type="text" v-model="pageName" />
            <span class="fs14 baseColor mr16 handle-btn" @click="cancleEditPageName">取消</span>
            <span class="fs14 baseColor handle-btn" @click="saveEditPageName(page)">保存</span>
          </div>
          <div class="right-btns">
            <span class="icon icon-portal-delete hover-show" @click="deletePage(page.encId, index)"></span>
          </div>
        </li>
      </draggable>
    </div>
    <div></div>
    <div
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      aria-label="提示"
      class="el-message-box__wrapper"
      style="z-index: 2024"
      v-show="showTemplates"
    >
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title" v-if="showSubPage">
            <div class="return-btn" @click="showSubPage = false"><i class="icon-portal-arrows-left"></i>{{ pageTitle }}</div>
          </div>
          <div class="el-message-box__title" v-else><span>添加页面</span></div>
          <button type="button" aria-label="Close" class="el-message-box__headerbtn" @click="closeTemplate">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="pop-content" v-if="!showSubPage">
            <div class="middle">
              <div class="page-name-wrap fs14 textColor mb16 verticallyCenter">
                <label class="mr16">页面名称</label>
                <input
                  type="text"
                  class="inp-name"
                  id="pageSearchKey"
                  placeholder="输入页面名称"
                  v-model="templatePageName"
                />
              </div>
              <div id="pageContainer">
                <p class="fs14 textColor">选择模板:</p>
                <ul class="templates-types">
                  <li
                    :class="type.encId === activeTemplateId ? 'active' : ''"
                    v-for="(type, index) in pageTemplateType"
                    :key="'type_' + index"
                    @click="changeTemplateType(type)"
                  >
                    {{ type.name }}
                  </li>
                </ul>
                <div v-show="pageTemplates.length == 0" class="empty">
                  <p class="fs14 col333">暂无内容~</p>
                </div>
                <ul class="pages-styles">
                  <li
                    class="fs12 col333"
                    v-for="(item, index) in pageTemplates"
                    :key="index"
                    :class="templatePageId === item.encId ? 'active' : ''"
                    @click="selectSubPage(item, index)"
                  >
                    <div class="cover-box">
                      <img
                        v-if="templatePageId === item.encId"
                        class="checked"
                        src="../assets/images/icon-checked.png"
                        alt=""
                      />
                      <img class="page-img" :src="item.cover" />
                    </div>
                    <p class="textColor">{{ item.name }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <ul class="pages-styles marginTop0 maxHeight500" v-if="showSubPage">
            <li
              v-for="(item, index) in subPageTemplate"
              :class="subTemplatePageId === item.encId ? 'active' : ''"
              :key="index"
              @click="selectTemplatePage(item, index)"
            >
              <div class="cover-box">
                <img
                  v-if="subTemplatePageId === item.encId"
                  class="checked"
                  src="../assets/images/icon-checked.png"
                  alt=""
                />
                <img class="page-img" :src="item.cover || defaultImgSrc" />
              </div>
              <p class="textColor">{{ item.name }}</p>
            </li>
          </ul>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small" @click="closeTemplate">
            <span> 取消 </span>
          </button>
          <button
            type="button"
            class="el-button el-button--default el-button--small el-button--primary"
            @click="nextClick"
            v-if="!showSubPage"
          >
            <span> 确定 </span>
          </button>
          <button
            type="button"
            class="el-button el-button--default el-button--small el-button--primary"
            @click="addSubPage"
            v-else
          >
            <span> 确定 </span>
          </button>
        </div>
      </div>
    </div>
    <el-dialog
      title="页面切换设置"
      width="440px"
      :append-to-body="false"
      :visible.sync="showSwiperSetting"
      custom-class="swiperSettingDialog"
    >
      <div class="setting-box colorfff">
        <div class="">
          <span class="mr16">切换模式</span>
          <el-radio-group v-model="autoplayType" @change="changeAutoPLayFunc()">
            <el-radio label="1">自动切换</el-radio>
            <el-radio label="2">手动切换</el-radio>
            <el-radio label="3">不切换</el-radio>
          </el-radio-group>
        </div>
        <div v-if="autoplayType == 1 || autoplayType == 2">
          <div class="mt16">
            <span class="mr16">切换效果</span>
            <el-radio-group v-model="directionType">
              <el-radio label="horizontal">向左滑动</el-radio>
              <el-radio label="vertical">向上滑动</el-radio>
              <el-radio label="fadeInOut">淡入淡出</el-radio>
            </el-radio-group>
          </div>
          <div class="speed-setting mt16" v-if="autoplayType === '1'">
            <div class="mt16">
              <span class="mr16">切换频率</span>
              <el-radio-group v-model="autoplayTimeSame" @change="changeAutoPLayTimeSameFunc()">
                <el-radio label="1">每页一致</el-radio>
                <el-radio label="2">每页自定义</el-radio>
              </el-radio-group>
            </div>
            <div class="mt16 ml72" v-if="autoplayTimeSame === '1'">
              <slider-and-input
                  :value.sync="autoPlaySpeed"
                  title=""
                  :sliderMax="3600"
                  :sliderMin="0"
                  suffix="秒"
                  inputWidth="small"
                  inputHeight="small"
              />
            </div>
            <div class="mt16 singlePageSet ml72" v-if="autoplayTimeSame === '2'">
              <div class="mt16 verticallyCenterBetween" v-for="(page, index) in pagelist" :key="index">
                <p class="overflowHid2" :title="page.name">{{ page.name }}</p>
                <single-input
                    class="mr12 width80"
                    :value.sync="autoplayTimeArr[index]"
                    inputSuffixs="秒"
                />
              </div>
            </div>
          </div>
          <cx-check-box class="mt16" v-if="directionType != 'vertical'" :value.sync="showArrow"
            >显示切换按钮</cx-check-box
          >
          <div class="arrow-setting mt16" v-if="showArrow && directionType != 'vertical'">
            <div class="" :class="{ autoType: arrowType == 'auto' }">
              <span class="mr16">切换按钮</span>
              <el-select v-model="arrowType" placeholder="请选择" @change="changeSelect()" ref="select">
                <template #prefix v-if="arrowType !== 'auto'">
                  <span class="ml8"><i :class="arrowIconName"></i></span>
                </template>
                <el-option
                  v-for="item in arrowTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  class="verticallyCenter"
                  :class="{ autoTypeOption: item.value == 'auto' }"
                >
                  <span class="option-icon" :class="item.imgClass"></span>
                  <span>{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="arrow-bg-input mt16" v-if="arrowType === 'auto'">
              <img-upload-simple :imgSrc.sync="arrowImgUrl" />
            </div>
            <div class="mt16 arrow-size-input">
              <double-input
                title="按钮尺寸"
                placeHolderText="必填"
                :value1.sync="arrowWidth"
                :value2.sync="arrowHeight"
                :inputSuffixs="['宽', '高']"
              />
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSwiperSetting = false">取 消</el-button>
        <el-button type="primary" @click="closeSwiperDialog()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs"
import "../assets/css/common.css"
import "../assets/icomoon/style.css"
import instance from "../interceptor"
import draggable from "vuedraggable"
import { getCookie } from "../utils/index"
import store from "../store"
import { getErrorMessage } from "utils/errorMessageMap.js"
export default {
  name: "bigScreenList",
  components: {
    draggable
  },
  data() {
    return {
      websiteId: undefined,
      wfwfid: undefined,
      pageId: undefined,
      pagelist: [],
      pagelistNew: [],
      pageOrder: [],
      originalList: [],
      autoPlaySpeed: 20,
      autoplay: true,
      autoplayType: "1",
      editIndex: undefined,
      pageName: "",
      pageTemplates: [],
      pageTemplateType: [],
      activeTemplateId: "78A9CCC5337333FC",
      contextPath: "",
      showTemplates: false,
      templatePageId: "",
      templatePageName: "",
      selectOption: [
        {
          label: "自动切换",
          value: true
        },
        {
          label: "手动切换",
          value: false
        }
      ],
      showArrow: true,
      showPagination: false,
      showSubPage: false,
      pageTitle: "",
      subTemplatePageId: "",
      subPageTemplate: [],
      defaultImgSrc: require("../assets/images/default_image.png"),
      showSwiperSetting: false,
      directionType: "horizontal",
      arrowType: "1",
      arrowIconName: "icon-portal-arrows-left",
      arrowTypeList: [
        {
          label: "样式1",
          imgClass: "el-icon-arrow-left",
          value: "1"
        },
        {
          label: "样式2",
          imgClass: "el-icon-back",
          value: "2"
        },
        {
          label: "样式3",
          imgClass: "icon-portal-arrow-left1",
          value: "3"
        },
        {
          label: "自定义",
          imgClass: "",
          value: "auto"
        }
      ],
      arrowImgUrl: "",
      arrowWidth: 64,
      arrowHeight: 64,
      autoplayTimeSame: "1",
      autoplayTimeArr: [],
    }
  },
  created() {
    const urlQuery = this.GetRequest()
    this.websiteId = urlQuery.w
    this.pageId = urlQuery.p
    this.getFid()
  },
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
    this.showPageList()
  },
  methods: {
    async getFid() {
      // let myCookie = await getCookie("website_fid")
      let myCookie = this.$store.state.states.myCookie
      this.wfwfid = myCookie.website_fid
    },
    GetRequest() {
      var url = window.previewUrl || location.href //获取url中"?"符后的字串
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.split("?")[1]
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
        }
      }
      return theRequest
    },
    backHistory() {
      this.$router.go(-1)
    },
    closeEditPageName: function (event) {
      if (!event.target.getAttribute("class") || !event.target.getAttribute("class").includes("page-name-inp")) {
        this.cancleEditPageName()
      }
    },
    getListOrder() {
      return this.$API.queryPageAttr({ websiteId: this.websiteId })
    },
    getListData() {
      return this.$API.queryEditPageList({
        websiteId: this.websiteId,
        pageId: this.pageId
      })
    },
    showPageList() {
      instance.all([this.getListData(), this.getListOrder()]).then(res => {
        const pageJson = res[1]?.data?.data?.pageListJson
        if (pageJson && pageJson.length) {
          const _p = JSON.parse(pageJson)
          if (_p.swiperOption) {
            const opt = _p.swiperOption
            this.autoPlaySpeed = opt.hasOwnProperty("time") ? opt.time : this.autoPlaySpeed
            this.autoplay = opt.hasOwnProperty("autoplay") ? opt.autoplay : this.autoplay
            this.showArrow = opt.hasOwnProperty("showArrow") ? opt.showArrow : this.showArrow
            this.directionType = opt.hasOwnProperty("directionType") ? opt.directionType : this.directionType
            this.arrowType = opt.hasOwnProperty("arrowType") ? opt.arrowType : this.arrowType
            this.arrowImgUrl = opt.hasOwnProperty("arrowImgUrl") ? opt.arrowImgUrl : this.arrowImgUrl
            this.arrowWidth = opt.hasOwnProperty("arrowWidth") ? opt.arrowWidth : this.arrowWidth
            this.arrowHeight = opt.hasOwnProperty("arrowHeight") ? opt.arrowHeight : this.arrowHeight
            this.autoplayType = opt.hasOwnProperty("autoplayType") ? opt.autoplayType : this.autoplayType
            this.autoplayTimeSame = opt.hasOwnProperty("autoplayTimeSame") ? opt.autoplayTimeSame : this.autoplayTimeSame
            this.autoplayTimeArr = opt.hasOwnProperty("autoplayTimeArr") ? opt.autoplayTimeArr : this.autoplayTimeArr
          }
        }
        this.originalList = res[0].data.data.pageList
        if (!res[1].data.data || !pageJson) {
          this.pagelist = this.originalList
          return
        }
        this.pageOrder = JSON.parse(pageJson).pages
        // 为了解决列表页展示的页面和接口返回的数据不一致的问题
        if(this.pageOrder.length !== this.originalList.length){
          this.pageOrder = []
          for (let j = 0; j < this.originalList.length; j++) {
            if (this.originalList[j].publicId) {
              this.pageOrder.push({
                pageId: this.originalList[j].publicId
              })
            }
          }
        }
        // 兼容改接口之后生成的一些无效数据
        for (let i = 0; i < this.pageOrder.length; i++) {
          if (!this.pageOrder[i].pageId) {
            this.pageOrder.splice(i, 1)
            i--
          }
        }
        this.pageOrder.forEach((item, index) => {
          for (let i = 0; i < this.originalList.length; i++) {
            if (this.originalList[i].encId == item.pageId || this.originalList[i].publicId == item.pageId) {
              this.pagelist[index] = this.originalList[i]
              // 做老数据的兼容，以前用的是encId   现在改用publicId
              if (this.originalList[i].encId == item.pageId) {
                item.pageId = this.originalList[i].publicId
              }
              break
            }
          }
        })
        this.$forceUpdate()
        this.pagelistNew = JSON.parse(JSON.stringify(this.pagelist))
      })
    },
    getNewPageList() {
      this.$API
        .queryEditPageList({
          websiteId: this.websiteId,
          pageId: this.pageId
        })
        .then(res => {
          this.pagelist = []
          this.originalList = res.data.data.pageList
          this.pageOrder.forEach((item, index) => {
            for (let i = 0; i < this.originalList.length; i++) {
              if (this.originalList[i].encId === item.pageId || this.originalList[i].publicId === item.pageId) {
                this.pagelist[index] = this.originalList[i]
                break
              }
            }
          })
          this.pagelistNew = JSON.parse(JSON.stringify(this.pagelist))
        })
    },
    editPageName(index, name) {
      this.editIndex = index
      this.pageName = name
    },
    cancleEditPageName() {
      this.editIndex = undefined
    },
    saveEditPageName(page) {
      this.pagelist[this.editIndex].name = this.pageName
      this.pagelistNew = JSON.parse(JSON.stringify(this.pagelist))
      this.editIndex = undefined
      this.$API
        .updatePageName({
          pageId: page.encId,
          name: this.pageName,
          wfwfid: this.wfwfid
        })
        .then(res => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            message: "修改成功",
            type: "success"
          })
        })
        .catch(err => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            message: "修改失败",
            type: "error"
          })
        })
    },
    //  删除page
    deletePage(encId, index) {
      this.$confirm("此操作将永久删除该页面, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$API
            .deletePage({
              pageId: encId,
              params: {
                wfwfid: this.wfwfid
              }
            })
            .then(res => {
              this.pageOrder.splice(index, 1)
              this.pagelist.splice(index, 1)
              this.pagelistNew = JSON.parse(JSON.stringify(this.pagelist))
              this.savePageSet(true)
              this.getNewPageList()
              // this.$message({
              //   customClass: "bigScreen_msg_backGroud",
              //   duration: 3000,
              //   message: "删除成功",
              //   type: "success"
              // })
            })
        })
        .catch(() => {
          // this.$message({ customClass: "bigScreen_msg_backGroud", duration: 3000, type: "info", message: "已取消删除" })
        })
    },
    selectSubPage(template) {
      this.pageTitle = template.name
      this.templatePageName = template.name
      this.templatePageId = template.encId
      // this.getSubPageList(template.encId)
    },
    nextClick() {
      this.getSubPageList(this.templatePageId)
    },
    selectTemplatePage(template, index) {
      this.templatePageName = template.name
      this.subTemplatePageId = template.encId
    },
    openTemplatePop() {
      this.showTemplates = true
      if (this.pageTemplates.length === 0) {
        this.getTemplateType()
        this.getTemplates()
      }
    },
    closeTemplate() {
      this.showTemplates = false
    },
    //获取页面模板类型
    getTemplateType() {
      let _this = this
      _this.$API.queryTemplateType().then(res => {
        _this.pageTemplateType = res.data.data
      })
    },
    changeTemplateType(type) {
      if (type.encId === this.activeTemplateId) {
        return
      }
      this.activeTemplateId = type.encId
      this.getTemplates()
    },
    //获取页面模板列表
    getTemplates: function () {
      let _this = this
      this.$API
        .queryTemplateList({
          t: this.activeTemplateId
        })
        .then(res => {
          _this.pageTemplates = res.data.data.list
        })
    },
    addPage: function () {
      this.$API
        .clonePage({
          w: this.websiteId,
          t: this.templatePageId,
          n: this.templatePageName
        })
        .then(res => {
          // if (res.data.status !== 200 || res.data.code === 0) {
          //   return Promise.reject({ message: res?.data?.message })
          // }
          this.pageOrder.push({
            pageId: res.data.data.publicId
          })
          this.pagelist.push(res.data.data)
          this.pagelistNew = JSON.parse(JSON.stringify(this.pagelist))
          this.savePageSet(true)
          this.getNewPageList()
          this.closeTemplate()
        })
        .catch(err => {
          this.$message({
            type: "error",
            customClass: "bigScreen_msg_backGroud",
            message: getErrorMessage(err?.message, true) || "添加失败"
          })
        })
    },
    addSubPage: function () {
      this.$API
        .clonePages({
          w: this.websiteId,
          ids: "ids" + encodeURI("[]") + "=" + this.subTemplatePageId
        })
        .then(res => {
          let len = res.data.data?.length
          if (len > 0) {
            this.pageOrder.push({
              pageId: res.data.data[len - 1]?.publicId
            })
            this.pagelist.push(res.data.data[len - 1])
            this.pagelistNew = JSON.parse(JSON.stringify(this.pagelist))
          }
          this.savePageSet(true)
          this.getNewPageList()
          this.closeTemplate()
        })
        .catch(err => {
          this.$message({
            type: "error",
            customClass: "bigScreen_msg_backGroud",
            message: getErrorMessage(err?.message, true) || "添加失败"
          })
        })
    },
    savePageSet: function (notUpdateOrder) {
      if (!notUpdateOrder || this.pageOrder.length !== this.pagelist.length) {
        let pages = []
        this.pagelist.forEach(item => {
          let page = {
            pageId: item.encId
          }
          pages.push(page)
        })
        this.originalList.forEach(item => {
          let hasVal = false
          for (let i = 0; i < pages.length; i++) {
            if (item.publicId === pages[i].pageId) {
              hasVal = true
              break
            } else if (item.encId === pages[i].pageId) {
              pages[i].pageId = item.publicId
              hasVal = true
              break
            }
          }
          if (!hasVal) {
            pages.push({ pageId: item.publicId })
          }
        })
        this.pageOrder = pages
      }
      this.$API
        .updatePageAttr({
          encWebId: this.websiteId,
          pageListJson: JSON.stringify({
            pages: this.pageOrder,
            swiperOption: {
              time: this.autoPlaySpeed,
              autoplay: this.autoplay,
              showArrow: this.showArrow,
              directionType: this.directionType,
              arrowType: this.arrowType,
              arrowImgUrl: this.arrowImgUrl,
              arrowWidth: this.arrowWidth,
              arrowHeight: this.arrowHeight,
              autoplayType: this.autoplayType,
              autoplayTimeSame: this.autoplayTimeSame,
              autoplayTimeArr: this.autoplayTimeArr
            }
          })
        })
        .then(res => {
          if (res.data.code === 1) {
            this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              message: "保存成功",
              type: "success"
            })
          }
        })
    },
    getSubPageList(encId) {
      let _this = this
      let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
      this.$API
        .queryPageListByTemplateId({
          templateId: encId
        })
        .then(res => {
          _this.subPageTemplate = res.data.data.pageList
          // 如果子页面大于1个 才能往下选择 否则直接添加
          if (_this.subPageTemplate?.length > 1) {
            _this.showSubPage = true
          } else {
            _this.addPage()
          }
        })
    },
    openSettingPop() {
      this.showSwiperSetting = true
      if(this.autoplayTimeSame == "2" && this.pagelist.length > 0 && this.pagelist.length !== this.autoplayTimeArr.length){
      //  每页自定义,新增的页面需要添加轮播时间
        for(let i=0; i< this.pagelist.length; i++){
          if(!this.autoplayTimeArr[i]){
            this.autoplayTimeArr[i] = this.autoPlaySpeed
          }
        }
      }
    },
    changeAutoPLayFunc() {
      if (this.autoplayType == 1) {
        this.autoplay = true
      } else {
        this.autoplay = false
        if (this.autoplayType == 3) {
          this.showArrow = false
        }
      }
    },
    //切换下拉框
    changeSelect() {
      for (let i = 0; i < this.arrowTypeList.length; i++) {
        let imgSrc = this.arrowTypeList[i].imgClass
        let val = this.arrowTypeList[i].value
        if (val == this.arrowType) {
          this.arrowIconName = imgSrc
        }
      }
    },
    closeSwiperDialog() {
      this.showSwiperSetting = false
      this.savePageSet(false)
    },
    //拖拽结束事件
    onEnd(event){
      this.pagelist = JSON.parse(JSON.stringify(this.pagelistNew))
      this.savePageSet(false)
    },
    changeAutoPLayTimeSameFunc(){
    //设置每个页面单独的停留时间
      if (this.autoplayTimeSame == 2 && this.pagelist.length > 0) {
        this.autoplayTimeArr = []
        this.pagelist.forEach(()=>{
          this.autoplayTimeArr.push(this.autoPlaySpeed)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bigScreen-list {
  // background: #fff;
  color: #ffffff;
}
.save {
  background: white;
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  width: 60px;
  height: 32px;
  padding: 0;
}
.page-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #2d3136;
  color: #fff;
}
.backpage:hover {
  color: var(--themeColor);
  cursor: pointer;
}
.page-top-r,
.page-top-l {
  width: 300px;
}
.talign-center {
  text-align: center;
}
.w1000 {
  width: 1000px;
}
.middle-content {
  margin: 24px auto;
}
.page-sets {
  padding: 0 20px 0 56px;
  box-sizing: border-box;
  justify-content: space-between;
}
.page-cover {
  width: 130px;
  height: 74px;
  margin-right: 20px;
  border-radius: 4px;
}
.page-list {
  position: relative;
  padding: 12px 20px 12px 56px;
  box-sizing: border-box;
  margin-bottom: 4px;
  border-radius: 8px;
}
.page-list .hover-show {
  display: none;
}
.page-list:hover {
  background: rgba(255, 255, 255, 0.08);
}
.page-list:hover .hover-show {
  display: inline-block;
}
.page-list .icon-portal-edit {
  color: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  cursor: pointer;
}
.page-list .icon-portal-delete {
  font-size: 18px;
}
.page-list .icon-portal-drag {
  position: absolute;
  z-index: 1;
  left: 20px;
  top: 50%;
  margin-top: -12px;
  color: rgba(255, 255, 255, 0.6);
}
.page-name span {
  font-weight: normal;
  cursor: pointer;
}
.page-name .first-tip {
  color: #ffffff;
  font-weight: normal;
}
.right-btns {
  width: 120px;
  text-align: right;
}
.icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}
.icon:hover {
  color: var(--themeColor);
  background-color: rgba(61, 130, 242, 0.1);
}
.icon-portal-delete {
  color: rgba(255, 255, 255, 0.6);
}
.icon-portal-drag {
  cursor: move;
}
.page-name {
  width: 638px;
  color: #ffffff;
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
}
.page-name-inp {
  width: 200px;
  height: 36px;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 0 8px;
  margin-right: 24px;
  font-size: 16px;
}
.el-message-box__wrapper {
  background: rgba(0, 0, 0, 0.4);
}
.el-message-box {
  width: 800px;
}
.pages-styles {
  font-size: 0;
  margin-top: 15px;
  max-height: 350px;
  overflow-y: auto;
  > li {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 16px;
    &:hover {
      .page-img {
        border: 2px solid var(--themeColor);
      }
    }
    &.active {
      .page-img {
        border: 2px solid var(--themeColor);
      }
    }
    &:not(:nth-child(3n)) {
      margin-right: 12px;
    }
  }
  p {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    word-break: break-all;
    max-width: 240px;
  }
  .cover-box {
    position: relative;
    width: 240px;
    height: 150px;
    text-align: center;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 10px;
    .page-img {
      border-radius: 8px;
      border: 2px solid var(--alertBackGround);
    }
    .checked {
      position: absolute;
      right: 0;
      top: 0;
      width: 32px;
    }
  }
  .page-img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  &.maxHeight500 {
    max-height: 500px;
  }
}
.inp-name {
  flex: 1;
  display: inline-block;
  vertical-align: middle;
  padding: 0 30px 0 8px;
  width: 240px;
  height: 30px;
  box-sizing: border-box;
  background: #35383f;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.8);
  &:hover,
  &:focus {
    border: 1px solid var(--themeColor);
  }
  &:focus + .icon-portal-search {
    color: var(--themeColor);
  }
  &::placeholder {
    color: rgba(255, 255, 255, 0.2);
  }
}
::v-deep .el-input .el-input__inner {
  color: var(--textColor);
  // background: #ffffff;
  // border: 1px solid #e9e9e9;
  background: #35383f;
  border: none;
}
::v-deep .el-slider__bar {
  background: var(--themeColor);
}
::v-deep .el-slider__button {
  border: 2px solid var(--themeColor);
  background-color: #fff;
}
::v-deep .el-message-box__wrapper .el-button--primary {
  color: #fff;
}
.el-button--primary.save {
  color: #fff;
}
.templates-types {
  margin-top: 4px;
  > li {
    display: inline-block;
    margin-right: 12px;
    margin-top: 12px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.6);
    height: 24px;
    line-height: 24px;
    font-size: 13px;
    padding: 0 8px;
    border-radius: 37px;
    &.active {
      color: #ffffff;
      background: var(--themeColor);
    }
  }
}
.el-message-box__header {
  padding: 15px 24px 15px;
  border-bottom: 1px solid rgba(49, 51, 54, 1);
}
.el-message-box__title {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.el-message-box__content {
  padding: 16px 14px 16px 24px;
}
.el-message-box__btns {
  padding: 16px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.07);
}
.el-message-box {
  padding-bottom: 0;
}
.icon-portal-plus {
  font-size: 12px;
}
#pageContainer .empty {
  text-align: center;
  padding: 50px 0;
  box-sizing: border-box;
}
.textColor {
  color: rgba(255, 255, 255, 0.8);
}
.marginTop0 {
  margin-top: 0;
}
.return-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
  i {
    font-size: 24px;
    margin-right: 4px;
  }
}
.colorfff {
  color: #fff;
}
.el-button.colorfff {
  color: #fff;
}
.arrow-size-input {
  width: 230px;
}
::v-deep .arrow-setting .el-select .el-input__prefix {
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 50%;
  text-align: center;
  line-height: 22px;
  width: 20px;
  height: 20px;
  top: 6px;
  left: 20px;
}
::v-deep .arrow-setting .el-select .el-input__prefix * {
  margin: 0;
}
::v-deep .arrow-setting .el-select .el-input__inner {
  padding-left: 50px;
}
.arrow-setting {
  padding: 16px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  background-color: rgba(44, 47, 51, 1);
  border: 1px solid rgba(55, 55, 55, 1);
}
.option-icon {
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 50%;
  text-align: center;
  line-height: 22px;
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.autoTypeOption .option-icon {
  display: none;
}
::v-deep .arrow-setting .autoType .el-select .el-input__inner {
  padding-left: 20px;
}
.arrow-bg-input {
  margin-left: 72px;
}
.speed-setting {
  width: 280px;
}
.singlePageSet{
  background-color: rgba(44, 47, 51, 1);
  padding: 8px 12px;
  width: 312px;
}
.singlePageSet p{
  max-height: 40px;
  overflow: hidden;
  max-width: calc(100% - 100px);
}
.verticallyCenterBetween{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
  .width80{
    width: 80px;
  }
  .ml72{
    margin-left: 72px;
  }
</style>
<style>
.bigScreen-list .el-radio__input.is-checked .el-radio__inner {
  background: transparent;
}
.bigScreen-list .el-radio__inner {
  background: transparent;
  border-color: rgba(97, 101, 109, 1);
}
.bigScreen-list .el-checkbox__inner {
  background: transparent;
}
</style>
